"use client";

import { siteConfig } from "@/config/site";
import { currentPhase, getCTAConfig } from "@/config/game-status";
import { useTranslation } from "@/i18n";
import { SectionWrapper, SectionEyebrow, SectionHeadline } from "@/components/ui/SectionWrapper";
import { FadeIn } from "@/components/ui/AnimatedSection";
import { Button } from "@/components/ui/Button";
import { SteamLogo } from "@/components/ui/SteamLogo";

export function WishlistCTA() {
    const cta = getCTAConfig(currentPhase, siteConfig.steamUrl);
    const { t } = useTranslation();

    return (
        <SectionWrapper className="py-8 md:py-10">
            <div className="relative rounded-2xl bg-surface border border-border overflow-hidden">
                {/* Background glow */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full bg-mars/8 blur-[120px]" />

                <div className="relative z-10 px-8 py-10 md:px-16 md:py-12 text-center max-w-2xl mx-auto">
                    <FadeIn>
                        <SectionEyebrow className="text-center">
                            {t.wishlist.eyebrow}
                        </SectionEyebrow>
                        <SectionHeadline className="text-center">
                            {t.wishlist.headline}
                        </SectionHeadline>
                        <p className="text-text-secondary leading-relaxed mb-8">
                            {t.wishlist.description}
                        </p>

                        {/* Reasons */}
                        <ul className="space-y-3 mb-10 text-left max-w-sm mx-auto">
                            {t.wishlist.reasons.map((reason) => (
                                <li
                                    key={reason}
                                    className="flex items-start gap-3 text-sm text-text-secondary"
                                >
                                    <svg
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        className="w-5 h-5 text-mars shrink-0 mt-0.5"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="M5 10l3 3 7-7"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                    <span>{reason}</span>
                                </li>
                            ))}
                        </ul>

                        <Button
                            variant="primary"
                            size="lg"
                            href={cta.primary.href}
                            external={cta.primary.external}
                        >
                            <SteamLogo
                                width={68}
                                height={17}
                                className="h-[17px] w-auto shrink-0 brightness-0 invert"
                            />
                            <span className="ml-2">{t.wishlist.cta}</span>
                        </Button>
                    </FadeIn>
                </div>
            </div>
        </SectionWrapper>
    );
}
